import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import config from './../../config';
import common from './../../common';
import {
    getMatchDetails,
} from './../../actions/ManageTeamActions';
import AdBottom from '../AdBottom';
import { find } from 'lodash';
import {
    playersFetchData,
    triggerHandlePlayerCard,
} from './../../actions/FormationActions';

class MatchDetails extends Component {
    componentDidMount() {
        const { matchId } = this.props;

        this.props.getMatchDetails(matchId);
        if (this.props.playerList.length <= 0) {
            this.getPlayers();
        }
    }

    getPlayers = () => {

        const playersPromise = this.props.fetchPlayers(this.props.constraints.leaderboardGamedayId);

    }

    backToMatches(e) {
        e.stopPropagation();
        return this.props.history.push('/matches');
    }

    printPlayerList(Players, TID) {

        return Players.map(function (p, index) {
            if (+p.TeamId === +TID) {
                return <li key={ p.PlayerId } onClick={ (e) => this.onPlayerInfo(e, p) } style={ { "cursor": "pointer" } }>
                    <span>{ p.PlayerName } { p.Count > 1 ? '(' + p.Count + ')' : '' }</span>
                </li>
            } else {
                return null;
            }
        }, this)
    }

    onPlayerInfo = (e, playerObj) => {
        e.stopPropagation();
        let playerInfoClicked = 'true';
        let pageNamere = "matchDetail";
        let overview = true;
        common.customTracking('Player Listing - Player Card', pageNamere);
        playerObj.Id = playerObj.PlayerId;

        const foundPlayer = find(this.props.playerList, function (player) {
            return player.Id == playerObj.Id;
        });

        if (foundPlayer) {
            this.props.triggerHandlePlayerCard(true, foundPlayer, false, overview, this.props.currGameday);
        } else {
            this.props.triggerHandlePlayerCard(true, playerObj, false, overview, this.props.currGameday);
        }


    }

    render() {
        const self = this;
        const { matchId } = this.props;
        const { matchDetails, trans } = this.props;
        const teamName = common.getTeamName();
        const matchDetailsStats = config.matchDetailsStats;
        if (Object.keys(matchDetails).length > 0 && +matchId === matchDetails.MID) {
            let { HTID, HTS, HTName, HTSName, ATID, ATS, ATName, ATSName } = matchDetails;
            let Stats = matchDetails.Stats || [];
            let HTImg = config.UEFAImgBase + `teams/logos/140x140/${HTID}.png`;
            let ATImg = config.UEFAImgBase + `teams/logos/140x140/${ATID}.png`;
            let matchStatus = parseInt(this.props.MStatus);
            let className = ""
            if (matchStatus === config.enumMatchStatus.isFinished) { //post
                className = "si-matCompleted"
            } else if (matchStatus === config.enumMatchStatus.isLock) { //live
                className = "si-matLiv"
            } else if (matchStatus === config.enumMatchStatus.isUpComing) { //pre
                className = "si-matUpcoming"
            }
            // return <div className="si-main-component si-manage-team si-no-anim si-matches">
            return <div className="si-team__details">
                <div className="si-container si-match-details">

                    {/* <div className="si-top-section">
                    <div className="si-heading-wrap si-flexBox">
                        <div className="si-title">
                            <span>{ trans.matchesDetails }</span>
                        </div>
                    </div>
                    <div className="si-overall-info si-flexBox">
                        <div className="si-back-btn si-cols">
                            <i className="icon-ucl-back_arrow" onClick={ (e) => this.backToMatches(e) } />
                        </div>
                        <div className="si-cols si-header-txt">
                            <span>{ teamName }</span>
                        </div>
                        <div className="si-more-options">
                            <i className="icon-ucl-more" />
                            <div className="si-more-menu"></div>
                        </div>
                    </div>
                </div> */}
                    <div className="si-fixture-wrap">

                        {
                            (Stats.length > 0) ?
                                Stats.map(function (evt, index) {
                                    const StatId = evt.StatId;
                                    const StatCode = evt.StatCode;
                                    const Players = evt.Players || [];
                                    const statClass = matchDetailsStats[StatCode] ? matchDetailsStats[StatCode].icon : '';
                                    const statName = matchDetailsStats[StatCode] ? matchDetailsStats[StatCode].transKey : '';
                                    return ((Players.length > 0 && matchDetailsStats[StatCode]) ? <div className={ "si-fixture-dtlsBox " + statClass } key={ StatId }>
                                        <div className="si-fixture-dtlsTitle">
                                            <span>{ trans[statName] }</span>
                                        </div>
                                        <div className="si-fixture-dtlsBody">
                                            <div className="si-fixture-dtls-icn"></div>
                                            <div className="si-fixture-dtls-fBox">
                                                <div className="si-fixture-dtls-fItem si-fixture-dtls-teamA">
                                                    <ul>
                                                        { self.printPlayerList(Players, HTID) }
                                                    </ul>
                                                </div>
                                                <div className="si-fixture-dtls-fItem si-fixture-dtls-teamB">
                                                    <ul>
                                                        { self.printPlayerList(Players, ATID) }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null)
                                }) : <div className="si-no-data">
                                    { trans.noData ? trans.noData : "No Data" }
                                </div>
                        }
                    </div>
                    {/* <AdBottom /> */}
                </div>
            </div>
        } else {
            return <div className="si-team__details"><div className="si-container si-match-details"><div className="si-loader-wrap" id="loader">
                <div className="si-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div></div></div>;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        matchDetails: state.formationData.matchDetails,
        playerList: state.formationData.players,
        constraints: state.appData.constraints,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getMatchDetails: (matchID) => dispatch(getMatchDetails(matchID)),
        triggerHandlePlayerCard: (isPlayerCardVisible, payload, playerinfoClicked, overview, gameday) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, payload, playerinfoClicked, overview, gameday)),
        fetchPlayers: (gamedayId) => dispatch(playersFetchData(gamedayId)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MatchDetails));


// WEBPACK FOOTER //
// ./src/components/matches/Match-Details.js